export type ConfirmationInputRule = {
  required?: boolean
  minLength?: number
  matchValue?: string
  validationMessage?: string
}

export function confirmationInputError(value: string, rule: ConfirmationInputRule): string {
  const normalized = value.trim()
  if (rule.required && !normalized) {
    return rule.validationMessage || 'Bu alan zorunludur.'
  }
  if (rule.minLength && normalized.length < rule.minLength) {
    return rule.validationMessage || `En az ${rule.minLength} karakter girin.`
  }
  if (rule.matchValue !== undefined && normalized !== rule.matchValue) {
    return rule.validationMessage || `Onay için ${rule.matchValue} yazın.`
  }
  return ''
}
